import { filterFalsy } from '../typescript';
import { getSupportedLocales } from '../locales/getSupportedLocales';
import { filterPseudo } from '../locales/utils';
import {
    LOCALE_IT,
    LOCALE_US,
    LOCALE_FR,
    LOCALE_DE,
    LOCALE_ES,
    LOCALE_PSEUDO,
    LOCALE_DEBUG,
} from '../locales/constants';
import { type Locale } from '../locales/constants';

type Pseudo = typeof LOCALE_PSEUDO | typeof LOCALE_DEBUG;

// Labels are intentionally untranslated
export const languageLabels: Record<Exclude<Locale, Pseudo>, string> = {
    [LOCALE_US]: 'English (US)',
    [LOCALE_FR]: 'Français',
    [LOCALE_DE]: 'Deutsch',
    [LOCALE_IT]: 'Italiano',
    [LOCALE_ES]: 'Español',
};

export function getLanguageOptions(localeToSortBy?: Locale): { value: Locale; label: string }[] {
    return getSupportedLocales()
        .filter(filterPseudo)
        .map(supportedLocale => {
            return {
                value: supportedLocale,
                label: languageLabels[supportedLocale],
            };
        })
        .filter(filterFalsy)
        .sort((a, z) => a.label.localeCompare(z.label, localeToSortBy));
}
